import { firestore as db, functions } from '@jaymathew/ui-shared/apis/FirebaseUtilities/FirebaseConfig'
import { collection, DocumentData, getDocs, query, QueryDocumentSnapshot, startAfter, where } from 'firebase/firestore'
import { httpsCallable, HttpsCallableResult } from 'firebase/functions'
import { getSelectedCompanyId } from 'shared/functions/selectedCompanyAccess'
import { Company } from 'resources/types'

// ============ Input Types ============

export interface CheckCompanyCodeInput {
	companyCode: string
}

// ============ Network Functions ============

export interface GetCompaniesReturnType<T> {
	payload: T[],
	lastDocument?: QueryDocumentSnapshot<DocumentData>
}

export const getCompanies = async (companyIDs: string[], lastDocument?: QueryDocumentSnapshot<DocumentData>): Promise<{ payload: Company[], lastDocument?: QueryDocumentSnapshot<DocumentData> }> => {

	if (companyIDs.length === 0) {
		return {
			payload: [],
			lastDocument: undefined,
		}
	}

	const collectionRef = collection(db, 'companies')
	let companiesCollectionRef = query(collectionRef, where('id', 'in', companyIDs))

	if (lastDocument) {
		companiesCollectionRef = query(companiesCollectionRef, startAfter(lastDocument))
	}

	const companiesCollection = await getDocs(companiesCollectionRef)

	if (companiesCollection.empty) {

		return {
			payload: [],
			lastDocument: undefined,
		}
	}

	const companies: Company[] = companiesCollection.docs.map((doc) => doc.data() as Company)

	return {
		payload: companies,
		lastDocument: companiesCollection.docs[companiesCollection.docs.length - 1],
	}
}

export const checkCompanyCode = async (companyCode: string): Promise<HttpsCallableResult> => {
	const callable = httpsCallable(functions, 'firebasefuncCheckCompanyCode')
	const result: HttpsCallableResult = await callable({ companyCode })
	return result
}

export const updateCompany = async (data: Partial<Company>): Promise<HttpsCallableResult> => {
	const companyID = getSelectedCompanyId() ?? ''
	const callable = httpsCallable(functions, 'firebasefuncUpdateCompany')
	const result: HttpsCallableResult = await callable({ companyID, ...data })
	return result
}
